
@switch (definition.type) {
  @case ('p') {
    <p>{{ definition.text }}</p>
  }
  @case ('span') {
    <span>{{ definition.text }}</span>
  }
  @default {
    <div>{{ definition.text }}</div>
  }
}
